// User configuration
export interface UserConfig {
  name: string;
  role?: string;
  facility?: string;
}

// Default user configuration - this would typically come from authentication or API
export const DEFAULT_USER_CONFIG: UserConfig = {
  name: "",
  role: "Nurse",
  facility: "Sunrise Senior Living"
};

// Function to get user config (could be extended to fetch from API/auth)
export function getUserConfig(): UserConfig {
  // In a real application, this would fetch from authentication service
  // For now, return the default config
  return DEFAULT_USER_CONFIG;
}
